var OCS = OCS || {};
OCS.Worker = OCS.Worker || {};
OCS.Worker.Live = OCS.Worker.Live || {};
OCS.Worker.Config = OCS.Worker.Config || {};
OCS.Worker.Classes = OCS.Worker.Classes || {};
OCS.Worker.Functions = OCS.Worker.Functions || {};
OCS.Worker.Functions.define_data_worker = function () {
    OCS.Worker.Classes.DataWorker = new Class({
        Implements: [Options, Events],
        socket_client: null,
        connect_success: false,
        active_ping: null,
        active_pong: null,
        bound_methods: {},
        cookies: {},
        stored_commands: [],
        resend_command_timeout: null,
        report_ping_timeout: null,
        pings_recieved: 0,
        request_manager: null,
        online_state: false,
        attempting_reconnect: false,
        options: {
            actively_retrieve_data: true,
            stored_command_retry_interval: 2000,
            manager_name: 'data_worker',
            polygon_amp_prefix: "poly_",
            ping_interval: 45000,
            ping_timeout: 3000,
            pings_before_reporting: 1,
            pubsub_prefix: 'pubsub',
            xmpp_login: 'xmpp.login',
            xmpp_login_device: "desktop",
            xmpp_login_jid: 'anon.feeds.dev.ok.mesonet.us',
            xmpp_node: 'feeds.dev.ok.mesonet.us',
            reconnect_retries: 15,
            allow_reinit: true,
            start_xmpp: true,
            debug: false
        },
        initialize: function (op) {
            if (OCS.Worker.Live.DataWorker) {
                return OCS.Worker.Live.DataWorker;
            }
            this.setOptions(op);
            this.bound_methods.process_command = this.process_command.bind(this);
            this.bound_methods.on_send_to_socket = this.on_send_to_socket.bind(this);
            this.bound_methods.on_send_to_ui = this.on_send_to_ui.bind(this);
            this.bound_methods.on_send_to_xmpp = this.on_send_to_xmpp.bind(this);
            this.bound_methods.process_data = this.process_data.bind(this);

            this.bound_methods.destroy = this.destroy.bind(this);
            this.request_manager = OCS.Functions.get_ajax_manager({storeCompletedReq: 60 * 60 * 1000});
            this.addEvent('xmpp_connected', this.on_xmpp_connected.bind(this));
            this.addEvent('logoff', this.on_logoff.bind(this));
            this.addEvent('send_ping', this.on_send_ping.bind(this));
            this.addEvent('pong_recieved', this.on_pong_recieved.bind(this));
            this.addEvent('send_to_socket', this.bound_methods.on_send_to_socket);
            this.addEvent('send_to_ui', this.bound_methods.on_send_to_ui);
            this.addEvent('send_to_xmpp', this.bound_methods.on_send_to_xmpp);
            if (OCS.is_worker) {
                var thread = OCS.Worker.Functions.get_processor();
                thread.addEvent('command', this.bound_methods.process_command);
                thread.addEvent('destroy', this.bound_methods.destroy);
                thread.addEvent('debug', this.set_debug.bind(this));
            }
            OCS.Worker.Live.DataWorker = this;

        },
        /*
         * 
         * Actions
         * 
         */
        make_subscription: function (channel, obj_ops) {
            /* istanbul ignore if */
            if (!OCS.Worker.Subscriptions[channel]) {
                if (this.options.debug) {
                    console.log("data_worker: SubscriptionObj created with " + channel + ". Dataset: " + obj_ops.dataset);
                }
                var sub_options = {
                    "channel_name": channel,
                    "dataset": obj_ops.dataset,
                    "debug": this.options.debug
                };
                var subobj = new OCS.Worker.Classes.SubscriptionObj(sub_options);
                subobj.addEvent('send_to_xmpp', this.bound_methods.on_send_to_xmpp);
            }
            return OCS.Worker.Subscriptions[channel];
        },
        login: function () {
            this.on_send_to_socket(this.options.xmpp_login, {
                jid: this.get_xmpp_jid(),
                password: 'a'
            });
            this.ping();
        },
        logoff: function () {
            Object.each(OCS.Worker.Subscriptions, function (sub_obj) {
                sub_obj.destroy();
            });
            if (this.online_state && this.socket_client) {
                this.socket_client.send(
                        'xmpp.presence',
                        {
                            show: 'offline',
                            priority: 1
                        }
                );
                this.fireEvent('logoff', null, 1);

            }

        },
        ping: function () {
            if (this.active_ping) {
                clearTimeout(this.active_ping);
                this.active_ping = null;
            }
            if (this.options.ping_interval) {
                this.active_ping = setTimeout(this.on_send_ping.bind(this), this.options.ping_interval);
            }
            if (this.active_pong) {
                clearTimeout(this.active_pong);
                this.active_pong = null;
            }
        },
        process_command: function (ev) {
            if (ev && ev.data && ev.data.cmd) {
                var data = ev.data;
                var ops = {};
                if (data.options) {
                    ops = data.options;
                }
                switch (data.cmd) {
                    case 'event':
                        var event_name = ops.event;
                        var event_data = ops.event_data;
                        if (event_name) {
                            this.fireEvent(event_name, event_data);
                        }
                        break;
                    case 'ping':
                        this.on_send_ping();
                        break;
                    case 'subscribe_init':
                        if (this.online_state) {
                            this.subscribe(ops);
                        } else {
                            this.store_command(ev);
                        }
                        break;
                    case 'subscribe_terminate':
                        if (this.online_state) {
                            this.unsubscribe(ops);
                        } else {
                            this.store_command(ev);
                        }
                        break;
                    case 'get_data':
                        this.get_data(ops);
                        break;
                    case 'set_config':
                        OCS.Worker.Config = ops;
                        break;
                    case 'set_user':
                        OCS.User = new OCS.Classes.User(ops);
                        break;
                    case 'set_actively_retrieve_data':
                        this.set_actively_retrieve_data(ops);
                        break;
                    case 'start':
                        this.start();
                        break;
                    case 'get_dates':
                        this.get_dates_array(ops, true);
                        break;
                    case 'stop':
                        this.destroy();
                        break;
                }
            }
        },
        process_data: function (data) {
            if (data && data.json) {
                if (data.json.features !== null && data.json.type === "FeatureCollection") {
                    // Correcting advisories to return a consistent format
                    data.json.payload = true;
                    data.json.data = {features: data.json.features, type: data.json.type};
                    delete data.json.features;
                    delete data.json.type;
                }

                if (data.json.payload) {
                    var metadata = data.request.get_passthrough_ops();
                    if (!data.json.dataset) {
                        data.json.dataset = metadata.dataset;
                    }
                    var data_ops = {entry: {json: data.json}, metadata: metadata};
                    if (metadata.data_type) {
                        data_ops.data_type = metadata.data_type;
                    }
                    var out_data = OCS.Functions.define_data_obj(data_ops);
                    if (data.request.options.url) {
                        out_data.set_url(data.request.options.url);
                    }
                    this.send_data_to_ui(out_data);
                } else {
                    // no payload, delete the response so we won't be stuck with it in the cache
                    delete data.request.response;
                }
            }
        },
        process_dates: function (data) {
            if (data && data.json) {
                var payload = false;
                if (data.json) {
                    payload = true;
                    var passthrough_ops = data.request.get_passthrough_ops();
                    var out_data = OCS.Functions.define_data_obj({entry: {json: {dates: data.json, payload: payload, dataset: passthrough_ops.dataset, info: passthrough_ops}}});
                    this.send_data_to_ui(out_data);
                }

            }
        },
        process_stored_commands: function () {
            if (this.resend_command_timeout) {
                clearTimeout(this.resend_command_timeout);
                this.resend_command_timeout = null;
            }
            var num_commands = this.stored_commands.length;
            for (var i = 0; i < num_commands; i++) {
                this.process_command(this.stored_commands.shift());
            }
            if (this.stored_commands.length) {
                this.resend_command_timeout = setTimeout(this.process_stored_commands.bind(this), this.options.stored_command_retry_interval);
            }
        },
        reconnect: function () {
            this.connect_success = false;
            this.online_state = false;
            console.warn("data_worker: Reconnection event occuring!");
            this.ping();
            if (this.options.allow_reinit) {
                OCS.Worker.Functions.send_to_main({cmd: 'reinit', options: {}});
            }
        },
        send_data_to_ui: function (data) {
            if (data) {
                OCS.Worker.Functions.send_to_main({cmd: 'data', options: data.stringify()});
            }
        },
        start: function () {
            this.get_socket_client();
        },
        store_command: function (ev) {
            if (!this.resend_command_timeout) {
                this.resend_command_timeout = setTimeout(this.process_stored_commands.bind(this), this.options.stored_command_retry_interval);
            }
            this.stored_commands.push(ev);
        },

        subscribe: function (obj_ops) {
            var channels = [];
            if (obj_ops && obj_ops.channels) {
                channels = obj_ops.channels;
            } else {
                channels = this.get_channels_from_options(obj_ops);
            }

            Object.each(channels, function (channel) {
                if (!OCS.Worker.Subscriptions[channel]) {
                    this.make_subscription(channel, obj_ops);
                }
                OCS.Worker.Subscriptions[channel].add_listener();
            }.bind(this));
        },

        unsubscribe: function (obj_ops) {
            var channels = this.get_channels_from_options(obj_ops);
            Object.each(channels, function (channel) {
                if (OCS.Worker.Subscriptions[channel]) {
                    OCS.Worker.Subscriptions[channel].remove_listener();
                }
            }.bind(this));
        },
        wait_for_pong: function () {
            if (this.active_pong) {
                clearTimeout(this.active_pong);
                this.active_pong = null;
            }
            this.active_pong = setTimeout(this.reconnect.bind(this), this.options.ping_timeout);
        },

        /*
         * 
         * Event Listeners
         * 
         */
        on_connection_ended: function () {
            this.online_state = false;
            this.connect_success = false;
            if (Object.keys(OCS.Worker.Subscriptions).length) {
                Object.each(OCS.Worker.Subscriptions, function (sub_obj) {
                    sub_obj.unsubscribe();
                });
            }
        },
        on_connection_re_established: function (opts) {
            this.reconnect();
            this.login();
            /* istanbul ignore if */
            if (this.options.debug) {
                console.debug('data_worker: It took %d ms to reconnect', opts.duration);
            }
        },
        on_logoff: function () {
            this.fireEvent('logged_off', null, 1);
        },

        on_ping_response: function (error, data) {
            this.fireEvent('pong_recieved', [data, this], 1);
            if (error) {
                this.reconnect();
                return;
            }
            if (data) {
                this.ping();
            }
        },
        on_pong_recieved: function () {
            if (this.active_pong) {
                clearTimeout(this.active_pong);
                this.active_pong = null;
            }
            this.pings_recieved++;
            var pings = (this.pings_recieved - 1) % this.options.pings_before_reporting;
            if (!pings) {
                OCS.Worker.Functions.send_to_main({'cmd': 'ping_status', 'options': {'action': 'Recieved', 'value': this.pings_recieved}});
            }
        },

        on_send_ping: function () {
            this.wait_for_pong();
            this.on_send_to_socket('xmpp.ping', {to: this.options.xmpp_node}, this.on_ping_response.bind(this));
            var pings = this.pings_recieved % this.options.pings_before_reporting;
            if (!pings) {
                OCS.Worker.Functions.send_to_main({'cmd': 'ping_status', 'options': {'action': 'Sent', 'value': this.pings_recieved + 1}});
            }
        },
        on_socket_client_open: function () {
            this.fireEvent('socket_open', this);
            this.login();
        },
        on_send_to_socket: function (cmd, ops, callback) {
            var socket = this.get_socket_client();
            if (callback) {
                socket.send(cmd, ops, callback);
            } else {
                socket.send(cmd, ops);
            }
        },
        on_send_to_ui: function (cmd, ops) {
            if (OCS.is_worker) {
                OCS.Worker.Functions.send_to_main({cmd: cmd, options: ops});
            } else {
                this.fireEvent('worker_message', {'cmd': cmd, 'options': ops}, 1);
            }
        },
        /*
         * on_send_to_xmpp - Making sending stuff to the xmpp socket accessible to events
         * @param {String} cmd
         * @param {String} channel
         * @param {Function} callback
         * @returns {undefined}
         */
        on_send_to_xmpp: function (cmd, channel, callback) {
            if (this.online_state) {
                this.on_send_to_socket(cmd, {
                    to: this.options.pubsub_prefix + '.' + this.options.xmpp_node,
                    node: channel,
                    jid: this.get_xmpp_jid()
                }, callback);
            }
        },
        on_xmpp_connection: function (data) {
            // Login was a success
            this.fireEvent('logged_in', [data, this]);
            this.on_send_to_socket('xmpp.presence', {
                show: 'chat',
                priority: 1
            });
        },
        on_xmpp_connected: function () {
            // We successfully connected
            this.connect_success = true;
            // Set online state to true so that the worker can accept sub request.
            this.online_state = true;
            this.attempting_reconnect = false;

            if (Object.keys(OCS.Worker.Subscriptions).length) {
                Object.each(OCS.Worker.Subscriptions, function (sub_obj) {
                    sub_obj.subscribe();
                });

            }
        },
        on_xmpp_error: function (data) {
            this.fireEvent('xmpp_error', [data, this]);
            if ((data.type === "cancel" && data.condition === "unknown")) {
                try {
                    var desc = JSON.parse(data.description);
                    var children = desc.stanza.children[1].children;
                    if (children.contains("User removed")) {
                        // We need to reconnect the xmpp, it got kicked, since it was a replacement connection.
                        this.online_state = false;
                        this.attempting_reconnect = true;
                        this.socket_client.destroy();
                        this.socket_client = null;
                        this.get_socket_client();
                    }
                    if (children.contains("Replaced by new connection")) {
                        this.socket_client.destroy();
                        this.socket_client = null;
                        OCS.Worker.Functions.send_to_main({'cmd': 'shutdown', 'options': {msg: "xmpp_device_kicked_off", event: OCS.Worker.Config.events.XMPP_DEVICE_KICKED}});
                        this.destroy();
                    }

                } catch (e) {
                    // We encountered a malformed json string in the description, for now ignore it.
                }
            }
            // attempting_reconnect keeps us from getting disconnected while attempting to re establish a connection
            if (!this.attempting_reconnect && (data.type === "connection" && data.condition === "not-connected" || data.condition === "disconnected")) {
                OCS.Worker.Functions.send_to_main({'cmd': 'restart', 'options': {msg: "xmpp_device_failed_to_connect", event: OCS.Worker.Config.events.XMPP_DEVICE_DISCONNECT}});
                this.destroy();
            }
        },
        on_xmpp_presence: function (data) {
            // We have a presence, connection established
            this.fireEvent('xmpp_connected', [data, this]);
        },
        on_xmpp_pubsub_push_item: function (data) {
            if (Object.keys(OCS.Worker.Subscriptions).contains(data.node)) {
                if (data.entry && data.entry.json && data.entry.json.cmd) {
                    // We have a command
                    OCS.Worker.Functions.send_to_main({'cmd': data.entry.json.cmd, 'options': data.entry.json.options});
                } else {
                    // We have data
                    data.data_type = "PubSubData";
                    var out_data = OCS.Functions.define_data_obj(data);
                    if (out_data.is_valid) {
                        if (out_data.is_valid()) {
                            OCS.Worker.Functions.send_to_main({'cmd': 'data', 'options': data});
                        }
                    } else {
                        OCS.Worker.Functions.send_to_main({'cmd': 'data', 'options': data});
                    }
                    this.ping();
                }
            } else {
                this.on_send_to_xmpp('xmpp.pubsub.unsubscribe', data.node, function () {});
            }
        },
        /*
         * 
         * Getters and Setters
         * 
         */

        get_channels_from_options: function (obj_ops) {
            var channels = [];
            var dataset = OCS.Datasets[obj_ops.dataset];
            var keys = dataset.get_string_keys(dataset.get_node_args());
            var base_metadata = Object.subset(obj_ops, keys);
            var metadata = {};
            if (obj_ops.variables.length) {
                obj_ops.variables.each(function (variable) {
                    metadata = OCS.Utilities.combine_objects(base_metadata, Object.subset(variable, keys));
                    channels.push(dataset.get_node_channel(metadata));
                }, this);
            } else {
                channels.push(dataset.get_node_channel(obj_ops));
            }
            return channels;
        },
        get_dates_array: function (options, async) {
            var dataURL, site, product, dateObj, variable;
            if (this.options.debug) {
                console.log("data_worker: Get dates.", options);
            }
            if (options.urls && options.urls.length === 1 && !options.url) {
                options.url = options.urls[0];
            }
            if (!options.url) {
                dateObj = new OCS.Classes.OCSDateTime();
                var long_start = dateObj.get_utc_long_string(options.start_epoch_time);
                var long_end = dateObj.get_utc_long_string(options.end_epoch_time);
                if (options.variables && options.variables.length) {
                    variable = options.variables[0];
                    site = variable.site;
                    product = variable.parm;
                }
                dataURL = OCS.Datasets[options.dataset].get_query_url({start: long_start, end: long_end, site: site, product: product});
            } else {
                dataURL = options.url;
            }
            var req = this.request_manager.request(dataURL, {'method': "get", 'url': dataURL, dataType: 'json', corsRequest: true, passthrough_ops: options});
            req.addEvent('success', this.process_dates.bind(this));
            req.send();

        },
        get_data: function (options) {
            if (this.options.debug) {
                console.log("data_worker: Retrieving data.", options);
            }

            var dataURL = options.url;
            switch (OCS.Datasets[options.dataset].get_datatype()) {
                case "lightning":
                    if (options.cookie) {
                        this.get_lightning_request(dataURL, options);
                    }
                    break;
                default:
                    //mesonet
                    //parse through each data var (sometimes there are multiples) and 
                    //create the urls to retrieve the data.
                    var req = this.request_manager.request(dataURL, {'method': "get", 'url': dataURL,
                        dataType: 'json', passthrough_ops: options
                    });
                    try {
                        req.removeEvent('success', this.bound_methods.process_data);
                    } catch (e) {
                    }
                    req.addEvent('success', this.bound_methods.process_data);
                    req.send();
                    break;
            }
        },
        get_jid_to_string: function (o) {
            var str = o.user + '@' + o.domain;
            if (o.resource) {
                str += '/' + o.resource;
            }
            return str;
        },
        get_xmpp_jid: function () {
            return this.get_jid_to_string({user: OCS.User.options.person_id, domain: this.options.xmpp_login_jid, resource: this.options.xmpp_login_device});
        },
        get_lightning_request: function (url, options) {
            var req = this.request_manager.request(url, {'method': "post", 'url': url,
                dataType: 'json', passthrough_ops: options
            });
            try {
                req.removeEvent('success', this.bound_methods.process_data);
            } catch (e) {
            }
            req.addEvent('success', this.bound_methods.process_data);
            req.send(encodeURI("session=" + options.cookie));
        },
        get_socket_client: function () {
            if (!this.socket_client && this.options.start_xmpp) {
                /* istanbul ignore if */
                if (typeof (Primus) === 'undefined') {
                    console.error("data_worker: Failed to load! Data Worker will not operate properly.");
                    return;
                }
                var socket = new Primus(OCS.Worker.Config.nodejs_subscriptions_url, {
                    reconnect: {
                        retries: this.options.reconnect_retries // Number: How many times we shoult try to reconnect.
                    }
                });
                if (socket && this.options.actively_retrieve_data) {
                    // Xmpp connection stuff
                    socket.on('open', this.on_socket_client_open.bind(this));
                    socket.on('xmpp.error', this.on_xmpp_error.bind(this));
                    socket.on('xmpp.connection', this.on_xmpp_connection.bind(this));
                    socket.on('xmpp.presence', this.on_xmpp_presence.bind(this));
                    socket.on('xmpp.pubsub.push.item', this.on_xmpp_pubsub_push_item.bind(this));
                    socket.on('reconnected', this.on_connection_re_established.bind(this));
                    socket.on('end', this.on_connection_ended.bind(this));
                }
                this.socket_client = socket;
            }
            return this.socket_client;
        },
        set_actively_retrieve_data: function (val) {
            this.options.actively_retrieve_data = val;
        },
        set_debug: function (val) {
            this.options.debug = val;
            Object.each(OCS.Worker.Subscriptions, function (sub_obj) {
                sub_obj.set_debug(val);
            });
        },

        /*
         * Destroy Methods
         */

        destroy: function () {
            if (this.resend_command_timeout) {
                clearTimeout(this.resend_command_timeout);
                this.resend_command_timeout = null;
            }
            if (this.active_ping) {
                clearTimeout(this.active_ping);
                this.active_ping = null;
            }
            if (this.active_pong) {
                clearTimeout(this.active_pong);
                this.active_pong = null;
            }
            this.stored_commands = [];
            this.logoff();
            if (this.socket_client && this.socket_client.destroy) {
                this.socket_client.destroy();
                this.socket_client = null;
                OCS.Worker.Functions.send_to_main({cmd: 'stopped', options: {}});
            } else {
                OCS.Worker.Functions.send_to_main({cmd: 'stopped', options: {}});
            }
            this.removeEvents();
            delete OCS.Worker.Live.DataWorker;
        }
    });

    if (OCS.is_worker) {
        // Kick off the thread with an understanding it will be running constantly
        OCS.Worker.Functions.get_processor();
    }
};
OCS.Worker.Functions.define_data_worker();

